import styled from "styled-components";

import {
  IconControl as IconControlDefault,
  Link as LinkDefault
} from "ds/Button";

export const Link = styled(LinkDefault)`
  width: 24px;
  height: 24px;
  display: flex;

  @media (max-width: 850px) {
    margin-left: auto;
  }
`;

export const IconControlConfigure = styled(IconControlDefault)`
  margin-left: auto;
`;
